import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { LearningActivityCardLink } from "Components/Module/LearningActivityItem/Actions";
import { LANG_KEY_NEXT_APPLICATION_START } from "../../constants";

const CourseCardActions = ({
  readMoreLink,
  title,
  languageContext,
  showNextApplicationSortDate = false,
  nextApplicationSortKeyLabel = "",
}) => {
  return (
    <>
      {showNextApplicationSortDate && (
        <Typography
          component="p"
          variant="body2"
          sx={{ color: "text.secondary", flex: 1, minWidth: 0, mr: 1 }}
        >
          {languageContext(LANG_KEY_NEXT_APPLICATION_START)}{" "}
          {nextApplicationSortKeyLabel}
        </Typography>
      )}
      <LearningActivityCardLink
        href={readMoreLink}
        title={`${languageContext("readmoreinfo")} ${title}`}
        aria-label={`${languageContext("readmoreCourse")} ${title}`}
      >
        {languageContext("readmore")}
      </LearningActivityCardLink>
    </>
  );
};

export default CourseCardActions;
